export const CNB_TYPE = {
    NONE: '',
    A: 'A', // A : 게임 사이트
    B: 'B', // B : 게임 프로모션, 업데이트 연대기 사이트 - 서비스 전체보기, BI, 로그인 / 로그아웃
    C: 'C', // C : 회원 사이트 (마이페이지, 고객센터, N샵)
    D: 'D', // D : 기타 사이트 (메인, 약관/정책, 공지사항, 장기 미이용 복귀 센터, 게임시간선택제)
    PURPLE: 'PURPLE' // PURPLE: 퍼플 웹뷰에서 사용하는 CNB
};

// 국가로 분기하지 않고 NCT, NCJ 권역값 추가 이유: NCK A-D타입 대만/일본과 CNB의 게임리스트와 다르게 구성해야 하므로
export const AREA_TYPE = {
    NCK: 'NCK', // CNB 파일이 NCK static에 존재 / 글로벌 대응 (TL, LW 등등)
    NCT: 'NCT', // CNB 파일이 NCT static에 존재 (NCT에서만 사용)
    NCJ: 'NCJ' // CNB 파일이 NCJ static에 존재 (NCJ에서만 사용)
};

export const COUNTRY_CODE = {
    NC: 'NC',
    KR: 'KR',
    TW: 'TW', // 대만
    JP: 'JP', // 일본
    RU: 'RU', // 러시아
    ID: 'ID', // 인도네시아
    TH: 'TH', // 태국
    MY: 'MY', //말레이시아 
    SA: 'SA', //사우디아라비아
    AE: 'AE', //아랍에미리트 
    QA: 'QA', //카타르 
    HK: 'HK', //홍콩 
    SG: 'SG', //싱가포르 
    PH: 'PH', //필리핀 
    US: 'US', //미국 
    CA: 'CA', //캐나다 
    DE: 'DE', //독일 
    GB: 'GB', //영국 
    FR: 'FR', //프랑스 
    BR: 'BR', //브라질 
    IT: 'IT', //이탈리아 
    ES: 'ES', //스페인 
    CL: 'CL', //칠레 
    NO: 'NO', //노르웨이 
    SE: 'SE', //스웨덴 
    IE: 'IE', //아일랜드 
    PT: 'PT', //포르투갈 
    FI: 'FI', //핀란드 
    DK: 'DK', //덴마크
    CH: 'CH', //스위스 
    AR: 'AR', //아르헨티나 
    PE: 'PE', //페루 
    MX: 'MX', //멕시코 
    KZ: 'KZ', //카자흐스탄 
    UZ: 'UZ', //우즈베키스탄 
    AZ: 'AZ', //아제르바이잔 
    GE: 'GE', //조지아 
    MD: 'MD', //몰도바 
    AM: 'AM', //아르메니아 
    UA: 'UA', //우크라이나 
    PL: 'PL', //폴란드 
    GR: 'GR', //그리스 
    BY: 'BY', //벨라루스 
    LT: 'LT', //리투아니아 
    IL: 'IL', //이스라엘 
    KW: 'KW', //쿠웨이트 
    AT: 'AT', //오스트리아 
    VN: 'VN', //베트남
    IN: 'IN', // 인도
    PK: 'PK', // 파키스탄
    NL: 'NL', // 네덜란드
    RO: 'RO', // 루마니아
    AU: 'AU', // 호주
    TR: 'TR', // 터키(튀르키예)
    EC: 'EC', // 에콰도르
    CO: 'CO', // 콜롬비아
    ZA: 'ZA', // 남아프리카공화국
    EG: 'EG' // 이집트
};

export const NETWORK = {
    opdev: 'opdev',
    sb: 'sb',
    rc: 'rc',
    stage: 'stage',
    live: 'live'
};

export const LNB_LINK_TYPE = {
    NEW: 'new',
    EXTERNAL: 'external',
    POPUP: 'popup'
}